import React from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import createNetworkingClient from 'utils/networking-client';

import Modal from 'components/shared/Modal';

import styles from './index.scss';

const I18nCloseModal = 'strava.settings.email_verification.close_modal';
const I18nHeadline = 'strava.settings.email_verification.headline';
const I18nPrompt = 'strava.settings.email_verification.prompt_html';
const I18nResendEmail = 'strava.settings.email_verification.resend_email_cta';
const I18nWrongEmail = 'strava.settings.email_verification.wrong_email_html';

const UrlResendVerificationEmail = '/athlete/resend_email';
const UrlChangeEmail = '/settings/email_change';

class EmailVerificationCTA extends React.Component {
  state = {
    modalIsOpen: false,
    resendEmailInProgress: false
  };

  componentDidMount() {
    if (this.props.resendOnMount) {
      this.resendEmail();
    }
  }

  /**
   * resendEmail will attempt to send another verification email to the athlete
   * and pop the success modal.
   *
   * - there is a lock around the operation.
   * - if the request fails the lock is removed but the modal is not popped
   */
  resendEmail = () => {
    const { resendEmailInProgress } = this.state;

    if (resendEmailInProgress) return;
    this.setState({ resendEmailInProgress: true });
    createNetworkingClient()
      .post(UrlResendVerificationEmail)
      .then(() =>
        this.setState({ modalIsOpen: true, resendEmailInProgress: false })
      )
      .catch(() => {
        this.setState({ resendEmailInProgress: false });
      }); // set here instead of finally due to FF polyfill issue
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { modalIsOpen } = this.state;
    const { children, className, email, optionalExplanation } = this.props;

    const cta = children ? (
      <button className={className} onClick={this.resendEmail}>
        {children}
      </button>
    ) : (
      <button
        className={`btn-link btn default ${className} ${styles.cta}`}
        onClick={this.resendEmail}
      >
        {I18n.t(I18nResendEmail)}
      </button>
    );

    return (
      <>
        {cta}
        <Modal
          className={styles.modal}
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
        >
          <div className={styles.dialog}>
            <button
              className={`${styles.closeButton} btn btn-unstyled btn-close`}
              onClick={this.closeModal}
              title={I18n.t(I18nCloseModal)}
            >
              <div className="app-icon icon-close icon-sm" />
            </button>
            <div className="text-body text-center">
              <div className={styles.confirmEmailIcon} />
              <h2 className="text-title2">{I18n.t(I18nHeadline)}</h2>
              {optionalExplanation && (
                <p className={`${styles.promptText} explanation`}>
                  {optionalExplanation}
                </p>
              )}
              <p className={styles.promptText}>
                {I18n.t_html(I18nPrompt, {
                  pending_email: email,
                  class_name: styles.emailText
                })}
              </p>
              <hr />
              <p className={`${styles.wrongEmailText} text-footnote`}>
                {I18n.t_html(I18nWrongEmail, {
                  email_settings_path: UrlChangeEmail
                })}
              </p>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

EmailVerificationCTA.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  email: PropTypes.string.isRequired,
  resendOnMount: PropTypes.bool,
  optionalExplanation: PropTypes.string
};

EmailVerificationCTA.defaultProps = {
  children: null,
  className: '',
  resendOnMount: false,
  optionalExplanation: ''
};

export default EmailVerificationCTA;
